import React from 'react';
import PropTypes from 'prop-types';
import CategoryField from 'components/field/CategoryField';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import listQueryFilter from 'components/hoc/listQueryFilter';
import { deleteSubcategory } from 'store/actions/subcategories/deleteSubcategories';
import { fetchSubcategories } from 'store/actions/subcategories/fetchSubcategories';

const SubcategoriesList = (props) => {
    const {
        actionType,
        location,
        resource,
        updateQuery,
    } = props;

    return (
        <div>
            <ResourceList
                action={ fetchSubcategories }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table>
                    <TextField
                        { ...props }
                        column={ {
                            sortable: true,
                            width: '60%',
                        } }
                        label='resources.subcategories.fields.name'
                        maxCharacters={ 100 }
                        source='name'
                    />

                    <CategoryField
                        column={ {
                            sortable: false,
                            width: '20%',
                        } }
                        label='resources.subcategories.fields.category_id'
                        reference='categories'
                        sortable={ false }
                        source='category_id'
                    />

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '10%',
                        } }
                        resource={ resource }
                    >
                        <EditAction />

                        <DeleteAction action={ deleteSubcategory } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

SubcategoriesList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    options: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default listQueryFilter(SubcategoriesList);



// WEBPACK FOOTER //
// ./src/pages/subcategories/list/SubcategoriesList.js